import { getActiveStoreId } from "@/lib/storeContext";

export const printerUsable = (p) => p && p.model !== "simulator" && String(p.ip || "").trim();

/** Stampante del ruolo per la sede: ignora i simulatori se esiste una termica/RT reale. */
export function pickPrinter(printers, role, storeId) {
  const sid = storeId === undefined ? getActiveStoreId() : storeId;
  const list = (Array.isArray(printers) ? printers : []).filter((p) => p && p.role === role);
  if (!list.length) return null;
  const preferReal = (arr) => (Array.isArray(arr) ? arr : []).find(printerUsable) || null;
  if (sid) {
    const exact = list.filter((p) => p.store_id === sid);
    const hit = preferReal(exact);
    if (hit) return hit;
  }
  const shared = list.filter((p) => !p.store_id);
  return preferReal(shared) || preferReal(list);
}

export function comandaPrintersForStore(printers, storeId) {
  const sid = storeId === undefined ? getActiveStoreId() : storeId;
  const all = (Array.isArray(printers) ? printers : []).filter((p) => p?.role === "comanda" && printerUsable(p));
  if (!sid) return all;
  const dedicated = all.filter((p) => p.store_id === sid);
  if (dedicated.length) return dedicated;
  return all.filter((p) => !p.store_id);
}
